import classes from './AnnouncementBanner.module.css';

const AnnouncementBanner = () => {
	return (
		<div className={classes.banner}>
			<div className={classes.bannerContent}>
				<span className={classes.bannerText}>
					🎉 After Newish's success, we've launched{' '}
					<strong>ResaleOS</strong>! Our new, state-of-the-art
					cross-listing tool.{' '}
					<a
						href="https://resaleos.co"
						target="_blank"
						rel="noopener noreferrer"
						className={classes.bannerLink}
					>
						Sign up at resaleos.co →
					</a>
				</span>
				<span className={classes.bannerNote}>
					Newish will be retired shortly.
				</span>
			</div>
		</div>
	);
};

export default AnnouncementBanner;

